import { useGenerateMatchScoreForSingleContact } from "@/features/contacts/hooks/useContacts";
import { NO_CAMPAIGNS_SCORE_HINT, useHasNoCampaigns } from "@/features/campaigns/hooks/useCampaign";
import CustomCommonTooltip from "@/shared/components/ui/Upload/ToolTip/CustomCommonTooltip";
import { Loader } from "lucide-react";
import React from "react";

const GenerateMatchScore = ({ item }) => {
  const {
    mutate: generateMatchScoreForSingleContact,
    isPending: isGeneratingMatchScoreForSingleContact,
  } = useGenerateMatchScoreForSingleContact();
  const hasNoCampaigns = useHasNoCampaigns();
  return (
    <CustomCommonTooltip content={hasNoCampaigns ? NO_CAMPAIGNS_SCORE_HINT : null}>
      <button
        key={item.id}
        type="button"
        // Not natively disabled when there are no campaigns, so the tooltip still shows on hover.
        className={`text-xs flex items-center gap-2 font-semibold text-secondary px-2 py-1 rounded-md transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary/35 focus-visible:ring-offset-1 ${hasNoCampaigns ? "opacity-50 cursor-not-allowed" : "hover:text-secondary/85"}`}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          if (hasNoCampaigns) return;
          generateMatchScoreForSingleContact({
            userId: item?.ownerId,
            contactId: item.id,
          });
        }}
        aria-disabled={hasNoCampaigns}
        disabled={isGeneratingMatchScoreForSingleContact}
      >
        {isGeneratingMatchScoreForSingleContact && (
          <Loader className="w-4 h-4 animate-spin" />
        )}
        {isGeneratingMatchScoreForSingleContact ? "Generating..." : "Generate"}
      </button>
    </CustomCommonTooltip>
  );
};

export default GenerateMatchScore;
